export default {
	updatedLabel: "updated {date}",
	confidenceLabel: "Confidence",
	progressLabel: "Progress",
	currentLabel: "Current",
	targetLabel: "Target",
};
